var SettingsScreensEnum = {
  customerSupport: 'customerSupport',
  messageSent: 'messageSent',
  messageSentError: 'messageSentError',
  account: 'account',
  termsAndConditions: 'termsAndConditions',
  privacyPolicy: 'privacyPolicy',
  settings: 'settings',
  changePassword: 'changePassword',
  changePasswordSuccess: 'changePasswordSuccess',
  changePasswordError: 'changePasswordError',
  updateEmail: 'updateEmail',
  updateEmailSuccess: 'updateEmailSuccess',
  updateEmailError: 'updateEmailError'
};
export default SettingsScreensEnum;